import { render, staticRenderFns } from "./course-sales-statistics.vue?vue&type=template&id=5fbd5b44&scoped=true"
import script from "./course-sales-statistics.vue?vue&type=script&lang=js"
export * from "./course-sales-statistics.vue?vue&type=script&lang=js"
import style0 from "./course-sales-statistics.vue?vue&type=style&index=0&id=5fbd5b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd5b44",
  null
  
)

export default component.exports